import React, { useEffect, useState } from "react";
import RoundNewIcon from "../../../../utils/svg/round-new-icon";
import AccordionArrowIcon from "../../../../utils/svg/accordion-arrow-icon";
import WarningIcon from "../../../../utils/svg/warning-icon";
import OnewayIcon from "../../../../utils/svg/oneway-icon";
import RoundIcon from "../../../../utils/svg/round-icon";
import TrashIcon from "../../../../utils/svg/trash-icon";
import { ONE_WAY, ROUND_TRIP } from "../../../../utils/consts";
import { getQuote, minutesToHours } from "../../../../utils/FlexxAPI";
import AccordionArrowUp from "../../../../utils/svg/accordion-arrow-up";

const mobileLeg = ({ leg, index, onDelete, onUpdate }) => {
    const [expanded, setExpanded] = useState(false);
    const [trips, setTrips] = useState(0);
    const [type, setType] = useState(leg.tripType);
    const [lock, setLock] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setTrips(leg.trips);
        setType(leg.tripType);
    }, [leg]);

    const handleTripUpdates = (e) => {
        const v = e.target.value <= 0 ? 1 : parseInt(e.target.value);
        setTrips(v);
        leg.trips = parseInt(v);
        leg.total = leg.estimate * leg.trips;
        leg.total = leg.total.toFixed(2);
        onUpdate(leg, index);
    };

    const handleTripType = (val) => {
        if (lock) {
            return;
        }
        setLock(true);
        setType(val);
        setLoading(true);

        try {
            getQuote(leg.from, leg.to, val, leg.plane, null).then(
                (response) => {
                    if (response.error) {
                        setLock(false);
                        setLoading(false);
                        return;
                    }

                    leg.trips = trips;
                    leg.estimate = response.flight_time; //Math.ceil((response.flight_time / 60) * Math.pow(10, 2)) / Math.pow(10, 2);
                    leg.additional = 0; // Math.ceil((response.block_time / 60) * Math.pow(10, 2)) / Math.pow(10, 2);
                    leg.total = leg.estimate * leg.trips;
                    // leg.total = leg.total.toFixed(2);
                    onUpdate(leg, index);
                    setLock(false);
                    setLoading(false);
                }
            );
        } catch (e) {
            setLock(false);
        }
    };

    return (
        <div className="flight-calculator__record">
            <div className="flight-calculator__accordion">
                {/* 
                <div className="flight-calculator__accordion__title">
                    <div className="flight-calculator__accordion__title-inner">
                        <div className="flight-calculator__accordion__from">
                            <p>
                                {leg.from.iata ? leg.from.iata + " |" : ""}{" "}
                                {!!leg.from.name && <b>{leg.from.name}</b>}
                            </p>
                        </div>
                        <div className="flight-calculator__accordion__to">
                            <p>
                                {leg.to.iata ? leg.to.iata + " |" : ""}{" "}
                                {!!leg.to.name && <b>{leg.to.name}</b>}
                            </p>
                        </div>
                    </div>
                    <span
                        onClick={() => {
                            setExpanded(!expanded);
                        }}
                    >
                        {expanded ? (
                            <AccordionArrowUp />
                        ) : (
                            <AccordionArrowIcon />
                        )}
                    </span>
                </div>
                {!!expanded && (
                */}
                <div className="flight-calculator__accordion__content">
                    <div className="flight-calculator__trip-data">
                        <div className="flight-calculator__way">
                            {/* <div className="flight-calculator__inputs">
                                <input
                                    type="text"
                                    readOnly={true}
                                    value={`${leg.from.iata} ${
                                        leg.from.name
                                            ? " | " + leg.from.name
                                            : ""
                                    }`}
                                />
                                <input
                                    type="text"
                                    readOnly={true}
                                    value={`${leg.to.iata} ${
                                        leg.to.name ? " | " + leg.to.name : ""
                                    }`}
                                />

                                {!!leg.fuel_stop && (
                                    <div className="flight-calculator__warning">
                                        <WarningIcon />
                                        <p>Fuel stop(s) required</p>
                                    </div>
                                )}
                            </div> */}
                            <div className="flight-calculator__accordion__title-inner">
                                <div className="flight-calculator__accordion__from">
                                    <p>
                                        {leg.from.iata
                                            ? leg.from.iata + " |"
                                            : ""}{" "}
                                        {!!leg.from.name && (
                                            <b>{leg.from.name}</b>
                                        )}
                                    </p>
                                </div>
                                <div className="flight-calculator__accordion__to">
                                    <p>
                                        {leg.to.iata ? leg.to.iata + " |" : ""}{" "}
                                        {!!leg.to.name && <b>{leg.to.name}</b>}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="flight-calculator__trip">
                            <div className="flight-calculator__trip__title">
                                <p>One Way or Round-Trip?</p>
                            </div>
                            <div className="flight-calculator__trip__content">
                                <div
                                    className={`flight-calculator__trip__button ${
                                        type === ONE_WAY ? "active" : ""
                                    }`}
                                    onClick={() => {
                                        handleTripType(ONE_WAY);
                                    }}
                                >
                                    <OnewayIcon />
                                </div>
                                <div
                                    className={`flight-calculator__trip__button ${
                                        type === ROUND_TRIP ? "active" : ""
                                    }`}
                                    onClick={() => {
                                        handleTripType(ROUND_TRIP);
                                    }}
                                >
                                    <RoundIcon />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flight-calculator__time">
                        <div className="flight-calculator__hours">
                            <p>
                                {loading
                                    ? "loading.."
                                    : minutesToHours(leg.estimate, 1)}{" "}
                                <span>/trip</span>
                            </p>
                        </div>
                        <div className="flight-calculator__trip-amount">
                            <input
                                type="number"
                                value={trips}
                                onChange={(e) => {
                                    handleTripUpdates(e);
                                }}
                            />
                            <p>
                                <b># of Trips</b>
                            </p>
                        </div>
                        <div className="flight-calculator__hours">
                            <p>
                                {loading
                                    ? "loading.."
                                    : minutesToHours(
                                          leg.estimate,
                                          leg.trips
                                      )}{" "}
                                <span>annually</span>
                            </p>
                            <span onClick={onDelete}>
                                <TrashIcon />
                            </span>
                        </div>
                    </div>
                </div>
                {/* )} */}
            </div>
        </div>
    );
};

export default mobileLeg;
